import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import "./Hero.css";
import heroship from "../assets/hero-1.png";
import heroimg2 from "../assets/hero-2.png"; 
import heroimg3 from "../assets/hero-3.png";
import heroimg4 from "../assets/hero-4.png";
import heroimg5 from "../assets/hero-5.png";
import heroimg6 from "../assets/hero-6.png";
import heroimg7 from "../assets/hero-7.png";
import heroimg8 from "../assets/hero-8.png";
import heroimg9 from "../assets/hero-9.png";
import heroimg10 from "../assets/hero-10.png";
import rightShape from "../assets/float-right.png"; 

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Hero = () => {
  const settings = {
  dots: true,
  infinite: true,
  speed: 800,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  arrows: true,
};

  return ( 
    <section className="hero">
      {/* Floating Dots */}
            <motion.div
              className="floating-dot orange"
              animate={{ y: [0, -20, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.div
              className="floating-dot blue"
              animate={{ y: [0, 25, 0] }}
              transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.div
              className="floating-dot green"
              animate={{ y: [0, -15, 0] }}
              transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
            />
            <motion.div
              className="floating-dot red"
              animate={{ y: [0, 30, 0] }}
              transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            />
            <div className="hero-right-shape">
    <img src={rightShape} alt="Right Decorative Shape" />
  </div>
      <Slider {...settings}>
        {/* Slide 1 */}

        <div className="hero-slide">
  <div className="hero-content">
    <h1>Empowering Industries For Over Four Decades</h1>
    <a href="/about" className="hero-btn">
      GET STARTED NOW
      <span className="hero-btn-icon">
        <FaArrowRight />
      </span>
    </a>
  </div>
  <motion.div
    className="hero-image"
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
  >
    <img src={heroimg10} alt="Hero Visual 1" />
  </motion.div>
</div>
        <div className="hero-slide">
          <div className="hero-content">
            <h1>Leading Distributor <br /> in Specialty Chemicals</h1>
           <a href="/about" className="hero-btn">
  GET STARTED NOW 
  <span className="hero-btn-icon">
    <FaArrowRight />
  </span>
</a>
          </div>
          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src={heroimg6} alt="Hero Visual" />
          </motion.div>
        </div>

        {/* Slide 2 */}
        <div className="hero-slide">
          <div className="hero-content">
            <h1>Empowering  Grinding <br /> Values</h1>
           <a href="/about" className="hero-btn">
  GET STARTED NOW 
  <span className="hero-btn-icon">
    <FaArrowRight />
  </span>
</a>
          </div>
          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src={heroimg2} alt="Hero Visual 2" />
          </motion.div>
        </div>

        {/* Slide 3 */}
        <div className="hero-slide">
          <div className="hero-content">
            <h1>Tailoring High  <br /> Performance Resources</h1>
            <a href="/about" className="hero-btn">
  GET STARTED NOW 
  <span className="hero-btn-icon">
    <FaArrowRight />
  </span>
</a>
          </div>
          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <img src={heroimg3} alt="Hero Visual 3" />
          </motion.div>
        </div>

<div className="hero-slide">
  <div className="hero-content">
    <h1>High Performing Wood Coatings</h1>
    <a href="/about" className="hero-btn">
      GET STARTED NOW
      <span className="hero-btn-icon">
        <FaArrowRight />
      </span>
    </a>
  </div>
  <motion.div
    className="hero-image"
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
  >
    <img src={heroimg5} alt="Hero Visual 2" />
  </motion.div>
</div>

<div className="hero-slide">
  <div className="hero-content">
    <h1>Bringing Resources Home</h1>
    <a href="/about" className="hero-btn">
      GET STARTED NOW
      <span className="hero-btn-icon">
        <FaArrowRight />
      </span>
    </a>
  </div>
  <motion.div
    className="hero-image"
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
  >
    <img src={heroimg7} alt="Hero Visual 2" />
  </motion.div>
</div>

<div className="hero-slide">
  <div className="hero-content">
    <h1>Cutting Edge Solutions</h1>
    <a href="/about" className="hero-btn">
      GET STARTED NOW
      <span className="hero-btn-icon">
        <FaArrowRight />
      </span>
    </a>
  </div>
  <motion.div
    className="hero-image"
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
  >
    <img src={heroimg8} alt="Hero Visual 2" />
  </motion.div>
</div>

<div className="hero-slide">
  <div className="hero-content">
    <h1>Anti Corrosion Coatings</h1>
    <a href="/about" className="hero-btn">
      GET STARTED NOW
      <span className="hero-btn-icon">
        <FaArrowRight />
      </span>
    </a>
  </div>
  <motion.div
    className="hero-image"
    initial={{ opacity: 0, x: 100 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ duration: 1 }}
  >
    <img src={heroimg9} alt="Hero Visual 2" />
  </motion.div>
</div>


      </Slider>
    </section>
  );
};

export default Hero;
